import axios, { AxiosError } from "axios";
const ConsignmentWaypointResource = {
    update(consignmentId, waypointId, request, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/consignments/${consignmentId}/waypoints/${waypointId}`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    patchContacts(consignmentId, waypointId, request, resultFunc, errorFunc, finallyFunc) {
        axios.patch(`/admin/v1/consignments/${consignmentId}/waypoints/${waypointId}`, request)
            .then((response) => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default ConsignmentWaypointResource;
